import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["loading"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 关闭项目 ")
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.className)
  }, [
    _withDirectives((_openBlock(), _createElementBlock("a", {
      href: "javascript:void(0);",
      loading: _ctx.loading,
      type: "link",
      danger: "",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDialog && _ctx.showDialog(...args))),
      style: {"color":"#ff4d4f"}
    }, _hoisted_3, 8, _hoisted_1)), [
      [_directive_perm, _ctx.access]
    ]),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.loading,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: "关闭项目 ",
      centered: true,
      onOk: _ctx.handleOk,
      onCancel: _ctx.cancel
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          layout: "vertical",
          ref: "formRef",
          model: _ctx.formModel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "项目关闭原因分类",
              name: "closeReasonType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formModel.closeReasonType,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.closeReasonType) = $event)),
                  disabled: "",
                  placeholder: "项目关闭原因分类"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "项目关闭原因",
              name: "projectCloseReason"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  "show-count": "",
                  value: _ctx.formModel.projectCloseReason,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.projectCloseReason) = $event)),
                  placeholder: "请输入说明，最多200字",
                  "auto-size": { minRows: 3 },
                  maxlength: 200,
                  allowClear: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible", "onOk", "onCancel"])
  ], 2))
}